import { Component, Input } from '@angular/core';
import { Advert } from "../../models/advert";

@Component({
    selector: 'advert-banner',
    templateUrl: 'advert-banner.html'
})
export class AdvertBannerComponent {

    @Input() advert: Advert;

}



// WEBPACK FOOTER //
// ./src/components/advert-banner/advert-banner.ts